import { render, staticRenderFns } from "./PromptManagement.vue?vue&type=template&id=2ab35172"
import script from "./PromptManagement.js?vue&type=script&lang=js&external"
export * from "./PromptManagement.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports